<!-- Checkout Recap -->
<div class="mb-6">
  <div class="bg-gray-200 mb-6 md:mb-8 px-4 py-3 rounded-lg">
    <h4 class="font-bold">
      Total amount due: ${{
        transaction.transaction.tdcTransaction?.balance | number: '1.2-2'
      }}
    </h4>
  </div>
  <div class="mb-4 w-full">
    <div
      class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
      <p>Seats</p>
      <p class="font-bold text-main">
        ${{
          transaction.transaction!.tdcTransaction?.totalPriceSeats ?? 0
            | number: '1.2-2'
        }}
      </p>
    </div>
  </div>

  @if (isTicketFeeEnabled()) {
    @for (serviceCharge of serviceChargesDetails; track $index) {
      @if (serviceCharge.amount) {
        <div class="mb-4 w-full">
          <div
            class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
            <p>{{ serviceCharge.name }}</p>
            <p class="font-bold text-main">
              ${{ serviceCharge.amount | number: '1.2-2' }}
            </p>
          </div>
        </div>
      }
    }
  } @else {
    @if (transaction.transaction.tdcTransaction?.serviceCharges) {
      <div class="mb-4 w-full">
        <div
          class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
          <p>Total ticket fees</p>
          <p class="font-bold text-main">
            ${{
              transaction.transaction.tdcTransaction?.serviceCharges
                | number: '1.2-2'
            }}
          </p>
        </div>
      </div>
    }
  }

  @if (transaction.transaction.tdcTransaction?.hasInsuranceRainout) {
    <div class="mb-4 w-full">
      <div
        class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
        <p>Rainout insurance</p>
        <p class="font-bold text-main">
          ${{
            transaction.transaction.tdcTransaction?.insuranceRainoutPrice
              | number: '1.2-2'
          }}
        </p>
      </div>
    </div>
  }
</div>

<!-- Terms & Conditions -->
<div class="mb-4 md:mb-2">
  <div class="flex items-center mb-1">
    <input
      type="checkbox"
      class="w-4 h-4"
      placeholder=""
      id="marketing"
      name="marketing"
      [value]="true"
      [(ngModel)]="paymentDetails.acceptedTerms" />
    <label for="marketing" class="ml-2 font-bold text-gray-600 text-xs"
      >I agree to the following</label
    >
  </div>
  <div class="h-32 overflow-y-auto text-gray-600 italic">
    <p class="mb-3">
      As part of your ticket purchase, you are required to acknowledge the
      <a
        [href]="configurationService.configuration.termsAndConditionsUrl"
        target="_blank"
        >{{ configurationService.configuration.clientName }} Ticket Terms and
        conditions</a
      >
      The Terms and conditions of your ticket and policies applicable to its use
      are updated to address circumstances related to COVID-19, health and
      safety, and seating pods. By clicking the Place Order button, you agree to
      accept all
      <a
        [href]="configurationService.configuration.termsAndConditionsUrl"
        target="_blank"
        >Terms and Conditions</a
      >
      applicable to ticket purchase, and all related policies. Further, due to
      the COVID-19 pandemic, scheduling may be impacted and games may be
      canceled, rescheduled, postponed or games may be held with limited
      capacity. Games may also have restricted capacity that prevents the use of
      specific seats. In the event that the game(s) for which the ticket(s) is
      issued does not occur or you are unable to use the specific seat(s)
      purchased, a refund or credit will be issued according to the refund
      policy available at
      <a
        [href]="configurationService.configuration.clientWebUrl"
        target="_blank"
        >{{ configurationService.configuration.clientWebText }}</a
      >
    </p>
    <p class="mb-3">
      By selecting the Place Order button you agree to purchase the tickets
      selected, to accept any restrictions noted, and understand you are
      responsible for any payment needed to complete the purchase. Upon
      completing your purchase by selecting the Place Order button, you
      acknowledge and agree your credit card will be charged. All sales are
      final. All tickets are subject to the
      <a
        [href]="configurationService.configuration.termsAndConditionsUrl"
        target="_blank"
        >Terms and Conditions</a
      >
    </p>
    <p class="mb-3">
      In connection with your purchase, you may receive customer service-related
      emails from the
      {{ configurationService.configuration.clientName }}, including optional
      surveys regarding your gameday experience. You also may receive
      ticket-related commercial email from the
      {{ configurationService.configuration.clientName }}. You may unsubscribe
      from ticket-related commercial emails at any time.
    </p>
  </div>
</div>
<!-- Extra Checkbox if exist in cfg client -->
@if (
  configurationService.configuration.extraCheckbox &&
  configurationService.configuration.extraCheckbox.active
) {
  <div class="mt-2 mb-4 md:mb-2">
    <div class="flex items-center mb-1">
      <input
        type="checkbox"
        class="w-4 h-4"
        placeholder=""
        id="extra-checkbox"
        name="extra-checkbox"
        [value]="true"
        [(ngModel)]="paymentDetails.extraCheckbox" />
      <label for="extra-checkbox" class="ml-2 font-bold text-gray-600 text-xs"
        >I agree to the following</label
      >
    </div>
    <div
      class="h-32 overflow-y-auto text-gray-600 italic"
      [innerHTML]="configurationService.configuration.extraCheckbox.text"></div>
  </div>
}
